// extracted by mini-css-extract-plugin
module.exports = {"volunteerCards":"VolunteerCards_volunteerCards__1UI3M","cardsContainer":"VolunteerCards_cardsContainer__2SfUl","card":"VolunteerCards_card__xos09"};